import React, { useState, useEffect } from "react";
import { AuthMe } from "../lib/MyHttp";
import { Update } from "../lib/User";
import { useTranslation } from "react-i18next";
import { typeSex, calculateAge } from "../lib/Common";
import moment from "moment";

const MyPage = () => {
    const { t } = useTranslation();

    const [data, setData] = useState({});

    useEffect(() => {
        AuthMe(res => {
            setData(res);
        });
    }, []);

    const guard_phones = data.guard_phone?.split(",");

    return (
        // 회원가입
        <main className="sub-contents">
            <section className="sub-top-section"></section>

            <div className="inner">
                <h2 className="sub_title">{t("마이효심")}</h2>
                <h3 className="sub_title_sm">My hyosim</h3>

                <div className="mypage_profile_wrapper">
                    <div className="pic">
                        <img src={data.image ? data.image : "https://picsum.photos/200/200"} alt="" />
                    </div>
                    <div className="text_box">
                        <p className="bolder">
                            {data?.name}
                            {t("님")}, {t("안녕하세요.")}
                        </p>
                        <p className="infos">
                            {t(typeSex[data.sex])} / {calculateAge(data.birth)}
                            {t("세")} / {data.addr1} {data.addr2} / {data.email}
                        </p>
                    </div>
                </div>

                <div className="mypage_top_box">
                    <h4 className="tit">{t("회원 정보")}</h4>
                    <a href="/modify/member" className="btn_nor line md">
                        {t("수정")}
                    </a>
                </div>
                <ul className="mypage_infos_ul">
                    <li>
                        <div className="sbj">{t("사 용 자")}</div>
                        <div className="cont">{data.name}</div>
                    </li>
                    <li>
                        <div className="sbj">{t("이 메 일")}</div>
                        <div className="cont">{data.email}</div>
                    </li>
                    <li>
                        <div className="sbj">{t("생년월일")}</div>
                        <div className="cont">{data.birth?.length === 10 ? moment(data.birth).format(t("YYYY년 MM월 DD일")) : ""}</div>
                    </li>
                    <li>
                        <div className="sbj">{t("아 이 디")}</div>
                        <div className="cont">{data.id}</div>
                    </li>
                    <li>
                        <div className="sbj">{t("성 별")}</div>
                        <div className="cont">{t(typeSex[data.sex])}</div>
                    </li>
                    <li>
                        <div className="sbj">{t("연 락 처")}</div>
                        <div className="cont">{data.phone}</div>
                    </li>
                    <li>
                        <div className="sbj">
                            {t("병력")}/{t("질환")}
                        </div>
                        <div className="cont">{data.medical}</div>
                    </li>
                    <li>
                        <div className="sbj">{t("주 소")}</div>
                        <div className="cont">
                            {data.addr1} {data.addr2}{" "}
                        </div>
                    </li>
                </ul>

                <div className="mypage_top_box">
                    <h4 className="tit">{t("보호자 정보")}</h4>
                    <a href="/modify/guardian" className="btn_nor line md">
                        {t("수정")}
                    </a>
                </div>
                <ul className="mypage_infos_ul">
                    {guard_phones?.map((x, index) => {
                        return (
                            <li>
                                <div className="sbj">
                                    {t("보호자")} {index + 1}
                                </div>
                                <div className="cont">{x}</div>
                            </li>
                        );
                    })}
                </ul>

                <div className="mypage_top_box">
                    <h4 className="tit">{t("기기 정보")}</h4>
                    <a href="/modify/device" className="btn_nor line md">
                        {t("수정")}
                    </a>
                </div>
                <ul className="mypage_infos_ul">
                    <li>
                        <div className="sbj">{t("기기이름")}</div>
                        <div className="cont">{data.device_sn}</div>
                    </li>
                    {/* <li>
                        <div className="sbj">기기등록번호</div>
                        <div className="cont">hyosim 01</div>
                    </li> */}
                </ul>

                <div className="mypage_top_box">
                    <h4 className="tit">
                        {t("푸쉬")} / {t("사운드 관리")}
                    </h4>
                </div>
                <ul className="mypage_infos_ul">
                    <li>
                        <div className="sbj">{t("푸쉬관리")}</div>
                        <div className="cont">
                            <p class="switch">
                                <input
                                    type="checkbox"
                                    name="confirm"
                                    class="switch_type"
                                    id="confirm_switch_1_1"
                                    checked={data.on_push === "Y"}
                                    onClick={() => {
                                        data.on_push = data.on_push === "Y" ? "N" : "Y";
                                        setData({ ...data });
                                        Update(data);
                                    }}
                                />
                                <label htmlFor="confirm_switch_1_1"></label>
                            </p>
                        </div>
                    </li>
                    <li>
                        <div className="sbj">{t("사운드 관리")}</div>
                        <div className="cont">
                            <p class="switch">
                                <input
                                    type="checkbox"
                                    name="confirm"
                                    class="switch_type"
                                    id="confirm_switch_1_2"
                                    checked={data.on_sound === "Y"}
                                    onClick={() => {
                                        data.on_sound = data.on_sound === "Y" ? "N" : "Y";
                                        setData({ ...data });
                                        Update(data);
                                    }}
                                />
                                <label htmlFor="confirm_switch_1_2"></label>
                            </p>
                        </div>
                    </li>
                </ul>

                <div className="mypage_top_box">
                    <h4 className="tit">{t("약관동의")}</h4>
                </div>
                <ul className="mypage_infos_ul">
                    <li>
                        <div className="sbj">{t("정보처리방침")}</div>
                        <div className="cont textR">
                            <a href="/policy" className="a_link">
                                {t("상세보기")}
                            </a>
                        </div>
                    </li>
                    <li>
                        <div className="sbj">{t("서비스 이용 약관")}</div>
                        <div className="cont textR">
                            <a href="/service" className="a_link">
                                {t("상세보기")}
                            </a>
                        </div>
                    </li>
                </ul>
            </div>
        </main>
    );
};

export default MyPage;
